var __rspack_ns_object = {"rE":"1.0.24"}